var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDownloads(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-download",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}@keyframes zoomIn{0%{opacity:0;transform:scale(.5)}to{opacity:1;transform:scale(1)}}@keyframes heartbeat{0%,30%,40%,60%,to{transform:scale(1)}10%,50%{transform:scale(1.1)}}@keyframes slideUp{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:inherit}}svg#freepik_stories-download:not(.animated) .animable{opacity:0}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-9",
    className: "animable",
    style: {
      transformOrigin: "250px 350.86px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 350.86,
    rx: 222.94,
    ry: 128.72,
    style: {
      fill: "#f5f5f5",
      transformOrigin: "250px 350.86px"
    },
    id: "el91qlmxkvpw4",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-9",
    className: "animable",
    style: {
      transformOrigin: "235.99px 352.791px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.78,
    cy: 364.13,
    rx: 32.53,
    ry: 18.78,
    style: {
      fill: "#e0e0e0",
      transformOrigin: "88.78px 364.13px"
    },
    id: "elc7jackmjaig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "145.7px 329.935px"
    },
    id: "el94yepm8jy4v",
    className: "animable",
    d: "m223.08 323.01-89.61 51.74-65.15-37.9 89.61-51.73 65.15 37.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.11 429.26 148.82 302.07a3 3 0 0 1 0-5.21l35.56-20.53a9.51 9.51 0 0 1 9.54 0l220.29 127.18a3 3 0 0 1 0 5.22l-35.55 20.53a9.58 9.58 0 0 1-9.55 0Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "281.519px 352.791px"
    },
    id: "elz74dklo5e4i",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-9",
    className: "animable",
    style: {
      transformOrigin: "420.366px 336.518px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m403.48 363.54 12.38 7.19s-6.25-19.94-2.78-40c1.31-7.58 4.06-11.34 5-13.36s8.44-14.54 1.87-20.3-22 5.7-21.3 36.6a119.76 119.76 0 0 0 4.83 29.87Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "410.624px 333.183px"
    },
    id: "elkj417qiexb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.48 363.54 12.38 7.19s-6.25-19.94-2.78-40c1.31-7.58 4.06-11.34 5-13.36s8.44-14.54 1.87-20.3-22 5.7-21.3 36.6a119.76 119.76 0 0 0 4.83 29.87Z",
    style: {
      opacity: 0.3,
      transformOrigin: "410.624px 333.183px"
    },
    className: "animable",
    id: "elkjk2ml18x1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.23 367.33a.45.45 0 0 1-.42-.29c-.05-.13-4.72-13.11-4.48-33.94s11.24-32.09 11.35-32.2a.45.45 0 0 1 .64.64c-.11.11-10.85 11-11.09 31.57s4.38 33.49 4.42 33.62a.44.44 0 0 1-.26.57.45.45 0 0 1-.16.03Z",
    style: {
      fill: "#fff",
      transformOrigin: "410.387px 334.049px"
    },
    id: "elncqj242zh4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407 365.4 20.46 12s9.36-1.38 8.65-10.19-4.51-10.9.23-14.77 6-4.13 5.73-7.93-2.78-5.45-4-7-4.55-4.66-2.2-9.24 5.56-9 .81-11.1c-2.83-1.25-7.59.32-10.75 3.67s-5.75 5.76-8.74 6.54-9.23.84-9 6 1.55 6.93.3 9.22c-2.4 4.4-12.49 6.68-1.49 22.8Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "422.034px 347.071px"
    },
    id: "elnvu5rtco9rh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.29 370.75a.46.46 0 0 1-.45-.41c0-.31-2.24-30.75 18.91-50.74a.44.44 0 0 1 .63 0 .46.46 0 0 1 0 .64c-20.83 19.69-18.65 49.71-18.62 50a.46.46 0 0 1-.41.49Z",
    style: {
      fill: "#fff",
      transformOrigin: "424.641px 345.109px"
    },
    id: "elemn2oqje53l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 344.61a.45.45 0 0 1-.45-.41 17.5 17.5 0 0 0-6.3-12.2.45.45 0 0 1-.1-.63.44.44 0 0 1 .62-.1 18 18 0 0 1 6.64 12.9.46.46 0 0 1-.42.48Z",
    style: {
      fill: "#fff",
      transformOrigin: "415.737px 337.917px"
    },
    id: "el2lzpcssjdwd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.45 349.82a.42.42 0 0 1-.3-.12.44.44 0 0 1 0-.63c.22-.24 5.53-6 17.79-4.28a.45.45 0 0 1 .39.5.46.46 0 0 1-.51.39c-11.76-1.62-16.95 3.93-17 4a.44.44 0 0 1-.37.14Z",
    style: {
      fill: "#fff",
      transformOrigin: "426.175px 347.146px"
    },
    id: "el73ty0gs98xo",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-9",
    className: "animable",
    style: {
      transformOrigin: "271.5px 269.044px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "369.785px 268.51px"
    },
    id: "elh99qssj74kw",
    className: "animable",
    d: "m384.06 273.54-28.55-16.72 17 23.38 11.55-6.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      transformOrigin: "369.785px 268.51px"
    },
    className: "animable",
    d: "m384.06 273.54-28.55-16.72 17 23.38 11.55-6.66z",
    id: "el3wpaqga249c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.09 335.42 200 238.94a4.71 4.71 0 0 1-2.36-4.08V120.77a4.72 4.72 0 0 1 7.07-4.09l167.11 96.48a4.73 4.73 0 0 1 2.36 4.09v114.09a4.72 4.72 0 0 1-7.09 4.08Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "285.91px 226.056px"
    },
    id: "elmlu7k9u2tul",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.51 280.2 11.55-6.66v135a6.91 6.91 0 0 1-3.47 6l-11.41 6.61Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "376.62px 347.345px"
    },
    id: "el2hab1n60jqu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.51 280.2 11.55-6.66v135a6.91 6.91 0 0 1-3.47 6l-11.41 6.61Z",
    style: {
      opacity: 0.3,
      transformOrigin: "376.62px 347.345px"
    },
    className: "animable",
    id: "elxu0j9ay4qo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.51 339.69 192.4 243.21a4.74 4.74 0 0 1-2.35-4.09V125a4.71 4.71 0 0 1 7.07-4.08l167.11 96.48a4.71 4.71 0 0 1 2.36 4.08V335.6a4.72 4.72 0 0 1-7.08 4.09Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "278.32px 230.304px"
    },
    id: "elf9yfzxib7mj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.92 344.15-167.1-96.47a4.73 4.73 0 0 1-2.36-4.09V129.5a4.71 4.71 0 0 1 7.07-4.08l167.11 96.48A4.71 4.71 0 0 1 359 226v114.07a4.72 4.72 0 0 1-7.08 4.08Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "270.73px 234.784px"
    },
    id: "elcey79tw4ubt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94 128v167.7a13.55 13.55 0 0 0 6.78 11.74l197 113.72a6.55 6.55 0 0 0 9.82-5.67V280.2l-103.9-60-17.95-41.4a39.24 39.24 0 0 0-16.4-18.39l-65.75-38a6.4 6.4 0 0 0-9.6 5.59Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "265.74px 271.794px"
    },
    id: "ela2i6ko3b9sl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94 128v167.7a13.55 13.55 0 0 0 6.78 11.74l197 113.72a6.55 6.55 0 0 0 9.82-5.67V280.2l-103.9-60-17.95-41.4a39.24 39.24 0 0 0-16.4-18.39l-65.75-38a6.4 6.4 0 0 0-9.6 5.59Z",
    style: {
      opacity: 0.2,
      transformOrigin: "265.74px 271.794px"
    },
    className: "animable",
    id: "eldvhv84uy3r8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.06 311c-.55-.32-1.1-.6-1.64-.85C313 297.25 304 282 293 275.64c-3.71-2.15-7.19-3-10.19-2.74-4.2-13.62-13.85-27-25.09-33.52-14.34-8.28-26.1-2.31-27.24 13.25-.69-.48-1.39-.93-2.09-1.34-10.89-6.28-19.71-1.19-19.71 11.38s8.82 27.86 19.71 34.14l86.7 50.06c8.59 5 15.55.94 15.55-9s-6.99-21.96-15.58-26.87Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "269.66px 292.33px"
    },
    id: "elh54exrxfd9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.06 311c-.55-.32-1.1-.6-1.64-.85C313 297.25 304 282 293 275.64c-3.71-2.15-7.19-3-10.19-2.74-4.2-13.62-13.85-27-25.09-33.52-14.34-8.28-26.1-2.31-27.24 13.25-.69-.48-1.39-.93-2.09-1.34-10.89-6.28-19.71-1.19-19.71 11.38s8.82 27.86 19.71 34.14l86.7 50.06c8.59 5 15.55.94 15.55-9s-6.99-21.96-15.58-26.87Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "269.66px 292.33px"
    },
    className: "animable",
    id: "el500yslxlvti"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "262.32px 312.895px"
    },
    id: "elqdz3dqjvv1q",
    className: "animable",
    d: "m241.19 309.83 20.43 37.25 21.83-13.23-8.63-4.87v-36.87l-23.26-13.4v37.17l-10.37-6.05z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-9",
    className: "animable animator-active",
    style: {
      transformOrigin: "179.007px 142.666px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn,1.5s Infinite linear heartbeat",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.42 74.42a102.53 102.53 0 0 0-97.73 71.52l-8.27-4.76a1.65 1.65 0 0 0-2.48 1.31 102 102 0 0 0 6.75 47.15 85 85 0 0 0 11.74 20.73 1.43 1.43 0 0 0 2.45-.36 95 95 0 0 1 14.74-25A93.11 93.11 0 0 1 123 171.5a2.19 2.19 0 0 0-.3-3.6l-9.92-5.73a88.4 88.4 0 0 1 171.74 5.55 102.53 102.53 0 0 0-102.1-93.3Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "179.007px 142.666px"
    },
    id: "el8skyor25u0g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.42 74.42a102.53 102.53 0 0 0-97.73 71.52l-8.27-4.76a1.65 1.65 0 0 0-2.48 1.31 102 102 0 0 0 6.75 47.15 85 85 0 0 0 11.74 20.73 1.43 1.43 0 0 0 2.45-.36 95 95 0 0 1 14.74-25A93.11 93.11 0 0 1 123 171.5a2.19 2.19 0 0 0-.3-3.6l-9.92-5.73a88.4 88.4 0 0 1 171.74 5.55 102.53 102.53 0 0 0-102.1-93.3Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "179.007px 142.666px"
    },
    className: "animable",
    id: "el9rusv8r2ip"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Files--inject-9",
    className: "animable",
    style: {
      transformOrigin: "355.51px 112.566px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideUp",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 359.15,
    cy: 60.29,
    rx: 23.58,
    ry: 40.84,
    style: {
      fill: "#b0bec5",
      transformOrigin: "359.15px 60.29px",
      transform: "rotate(-30deg)"
    },
    className: "animable",
    id: "elsvh2dd30la"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 359.15,
    cy: 60.29,
    rx: 23.58,
    ry: 40.84,
    style: {
      opacity: 0.2,
      transformOrigin: "359.15px 60.29px",
      transform: "rotate(-30deg)"
    },
    className: "animable",
    id: "elt1pt0blfk8n"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 357.45,
    cy: 61.26,
    rx: 23.58,
    ry: 40.84,
    style: {
      fill: "#b0bec5",
      transformOrigin: "357.45px 61.26px",
      transform: "rotate(-30deg)"
    },
    className: "animable",
    id: "ellzia3dv0o1i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346 71 22.23 12.9a1.78 1.78 0 0 0 2.68-1.54v-27.5a3.89 3.89 0 0 0-2-3.37l-22.23-12.86a1.78 1.78 0 0 0-2.68 1.54v27.5a3.89 3.89 0 0 0 2 3.33Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "357.455px 61.265px"
    },
    id: "eldn2p9bgglv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346 71 22.23 12.9a1.78 1.78 0 0 0 2.68-1.54v-27.5a3.89 3.89 0 0 0-2-3.37l-22.23-12.86a1.78 1.78 0 0 0-2.68 1.54v27.5a3.89 3.89 0 0 0 2 3.33Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "357.455px 61.265px"
    },
    className: "animable",
    id: "elhwwhrvco6tj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.23 67 17.87 10.27a1.42 1.42 0 0 0 2.14-1.27V55.4a3.12 3.12 0 0 0-1.56-2.7l-17.87-10.31a1.43 1.43 0 0 0-2.14 1.24v20.63a3.12 3.12 0 0 0 1.56 2.74Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "357.455px 59.8339px"
    },
    id: "elb83rcrrk3fd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.24 55.4V76a1.42 1.42 0 0 1-2.14 1.24L348.23 67a3.09 3.09 0 0 1-1.56-2.69V43.63a1.42 1.42 0 0 1 2.14-1.24l17.87 10.32a3.09 3.09 0 0 1 1.56 2.69Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "357.455px 59.815px"
    },
    className: "animable",
    id: "el69dhgi639ar"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.24 75.27V76a1.42 1.42 0 0 1-2.14 1.24L348.23 67a3.09 3.09 0 0 1-1.56-2.69v-2l4.68-4 5.52 7.86 5.39-6.41Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "357.455px 67.8731px"
    },
    id: "eliz0kd2dfzjm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.83 52.12a5.34 5.34 0 0 0 2.4 4.17c1.33.77 2.41.15 2.41-1.39a5.34 5.34 0 0 0-2.41-4.17c-1.32-.73-2.4-.14-2.4 1.39Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "355.235px 53.5197px"
    },
    id: "ela0zfn9jeqvt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 409.2,
    cy: 162.96,
    rx: 23.58,
    ry: 40.84,
    style: {
      fill: "#b0bec5",
      transformOrigin: "409.2px 162.96px",
      transform: "rotate(-30deg)"
    },
    className: "animable",
    id: "eldi9qbkk1wj"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 409.2,
    cy: 162.96,
    rx: 23.58,
    ry: 40.84,
    style: {
      opacity: 0.2,
      transformOrigin: "409.2px 162.96px",
      transform: "rotate(-30deg)"
    },
    className: "animable",
    id: "elb2xi0dqign"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 407.5,
    cy: 163.94,
    rx: 23.58,
    ry: 40.84,
    style: {
      fill: "#b0bec5",
      transformOrigin: "407.5px 163.94px",
      transform: "rotate(-30deg)"
    },
    className: "animable",
    id: "elc4g49g9ex"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.73 141.3a1.79 1.79 0 0 0-2.68 1.55v27.5a3.87 3.87 0 0 0 1.95 3.36l22.28 12.87A1.78 1.78 0 0 0 421 185v-20.41l-6-12.79Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "407.526px 163.956px"
    },
    id: "elhxjjhlvhas5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.73 141.3a1.79 1.79 0 0 0-2.68 1.55v27.5a3.87 3.87 0 0 0 1.95 3.36l22.28 12.87A1.78 1.78 0 0 0 421 185v-20.41l-6-12.79Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "407.526px 163.956px"
    },
    className: "animable",
    id: "elpk1uscepond"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.13 156.48.78-4.68 6 12.8-5.45-4.49a3.87 3.87 0 0 1-1.33-3.63Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "417.492px 158.2px"
    },
    id: "elnawaq64p0zn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.13 156.48.78-4.68 6 12.8-5.45-4.49a3.87 3.87 0 0 1-1.33-3.63Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "417.492px 158.2px"
    },
    className: "animable",
    id: "el40ywikpjrvi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.3 167.22a.61.61 0 0 1-.31-.09L398.4 157a.62.62 0 0 1-.22-.84.61.61 0 0 1 .83-.22l17.6 10.15a.62.62 0 0 1 .22.84.6.6 0 0 1-.53.29Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "407.505px 161.54px"
    },
    id: "elsc437t6rdvc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.3 173.18a.71.71 0 0 1-.31-.08l-17.59-10.16a.62.62 0 0 1-.22-.84.61.61 0 0 1 .83-.22l17.6 10.12a.62.62 0 0 1 .22.84.6.6 0 0 1-.53.34Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "407.505px 167.489px"
    },
    id: "el7afikzxwl95",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.3 179.14a.71.71 0 0 1-.31-.08L398.4 168.9a.62.62 0 0 1-.22-.84.61.61 0 0 1 .83-.22l17.6 10.16a.61.61 0 0 1-.31 1.14Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "407.508px 173.449px"
    },
    id: "el7d7xdd6n39u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 303.51,
    cy: 103,
    rx: 23.58,
    ry: 40.84,
    style: {
      fill: "#b0bec5",
      transformOrigin: "303.51px 103px",
      transform: "rotate(-29.8865deg)"
    },
    className: "animable",
    id: "elz53nz9903sq"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 303.51,
    cy: 103,
    rx: 23.58,
    ry: 40.84,
    style: {
      opacity: 0.2,
      transformOrigin: "303.51px 103px",
      transform: "rotate(-29.8865deg)"
    },
    className: "animable",
    id: "ellsh3yhpewb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.82,
    cy: 103.97,
    rx: 23.58,
    ry: 40.84,
    style: {
      fill: "#b0bec5",
      transformOrigin: "301.82px 103.97px",
      transform: "rotate(-30deg)"
    },
    className: "animable",
    id: "elj5dv9zzfkvn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.31 113.75 22.28 12.86a1.78 1.78 0 0 0 2.68-1.54v-27.5a3.89 3.89 0 0 0-1.95-3.37L291 81.34a1.78 1.78 0 0 0-2.67 1.54v27.5a3.9 3.9 0 0 0 1.98 3.37Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "301.8px 103.978px"
    },
    id: "els8mx7tehknp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.31 113.75 22.28 12.86a1.78 1.78 0 0 0 2.68-1.54v-27.5a3.89 3.89 0 0 0-1.95-3.37L291 81.34a1.78 1.78 0 0 0-2.67 1.54v27.5a3.9 3.9 0 0 0 1.98 3.37Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "301.8px 103.978px"
    },
    className: "animable",
    id: "elewakjpuex3h"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.38 99.31v9.33a1.39 1.39 0 0 0 1.39 1.39h8.09a1.39 1.39 0 0 0 1.05-2.3l-8.09-9.33a1.39 1.39 0 0 0-2.44.91Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "301.815px 103.975px"
    },
    id: "eleio0jvf0bq6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.15 100.52a.71.71 0 0 1-.71-.71v-1.89a.71.71 0 0 1 .71-.71.7.7 0 0 1 .7.71v1.89a.7.7 0 0 1-.7.71Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "359.145px 98.865px"
    },
    id: "el53mkugvgagd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.15 206.3a.71.71 0 0 1-.71-.71v-3.78a.71.71 0 0 1 .71-.71.7.7 0 0 1 .7.71v3.78a.7.7 0 0 1-.7.71Zm0-7.56a.71.71 0 0 1-.71-.71v-3.77a.71.71 0 0 1 .71-.71.7.7 0 0 1 .7.71V198a.7.7 0 0 1-.7.74Zm0-7.55a.71.71 0 0 1-.71-.71v-3.78a.71.71 0 0 1 .71-.71.7.7 0 0 1 .7.71v3.78a.7.7 0 0 1-.7.71Zm0-7.56a.71.71 0 0 1-.71-.71v-3.78a.7.7 0 0 1 .71-.7.7.7 0 0 1 .7.7v3.78a.7.7 0 0 1-.7.71Zm0-7.55a.71.71 0 0 1-.71-.71v-3.78a.71.71 0 0 1 .71-.71.7.7 0 0 1 .7.71v3.78a.7.7 0 0 1-.7.71Zm0-7.56a.71.71 0 0 1-.71-.71V164a.71.71 0 0 1 .71-.71.7.7 0 0 1 .7.71v3.78a.7.7 0 0 1-.7.74Zm0-7.56a.7.7 0 0 1-.71-.7v-3.78a.71.71 0 0 1 .71-.71.7.7 0 0 1 .7.71v3.78a.7.7 0 0 1-.7.74Zm0-7.55a.71.71 0 0 1-.71-.71v-3.78a.71.71 0 0 1 .71-.71.7.7 0 0 1 .7.71v3.78a.7.7 0 0 1-.7.71Zm0-7.56a.71.71 0 0 1-.71-.71v-3.77a.71.71 0 0 1 .71-.71.7.7 0 0 1 .7.71v3.77a.7.7 0 0 1-.7.71Zm0-7.55a.71.71 0 0 1-.71-.71v-3.78a.71.71 0 0 1 .71-.71.7.7 0 0 1 .7.71v3.78a.7.7 0 0 1-.7.71Zm0-7.56a.71.71 0 0 1-.71-.71v-3.78a.7.7 0 0 1 .71-.7.7.7 0 0 1 .7.7V130a.7.7 0 0 1-.7.74Zm0-7.55a.71.71 0 0 1-.71-.71v-3.78a.71.71 0 0 1 .71-.71.7.7 0 0 1 .7.71v3.78a.7.7 0 0 1-.7.71Zm0-7.56a.71.71 0 0 1-.71-.71v-3.78a.71.71 0 0 1 .71-.71.7.7 0 0 1 .7.71v3.78a.7.7 0 0 1-.7.71Zm0-7.56a.7.7 0 0 1-.71-.7v-3.78a.71.71 0 0 1 .71-.71.7.7 0 0 1 .7.71v3.78a.7.7 0 0 1-.7.7Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "359.146px 154.59px"
    },
    id: "elj3kfsh1ys3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.15 212a.7.7 0 0 1-.71-.7v-1.89a.71.71 0 0 1 .71-.71.7.7 0 0 1 .7.71v1.89a.7.7 0 0 1-.7.7Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "359.145px 210.35px"
    },
    id: "elf8paezqxtvi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377 165.49a.69.69 0 0 1-.63-.39.7.7 0 0 1 .32-.95l1.69-.84a.7.7 0 1 1 .63 1.26l-1.69.85a.71.71 0 0 1-.32.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "377.847px 164.362px"
    },
    id: "el1l7fso1wusp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.68 169.63a.69.69 0 0 1-.63-.39.7.7 0 0 1 .32-1l4.16-2.07a.71.71 0 0 1 1 .32.71.71 0 0 1-.32 1l-4.21 2.07a.71.71 0 0 1-.32.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "370.788px 167.853px"
    },
    id: "el8oitozx8kvk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.83 172.54a.69.69 0 0 1-.63-.39.7.7 0 0 1 .32-1l1.69-.84a.71.71 0 0 1 1 .32.71.71 0 0 1-.32.95l-1.69.84a.71.71 0 0 1-.37.12Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "363.692px 171.378px"
    },
    id: "eljduu0xq6cul",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.65 121.3a.69.69 0 0 1-.6-.34l-1-1.62a.7.7 0 0 1 .23-1 .72.72 0 0 1 1 .24l1 1.62a.7.7 0 0 1-.61 1.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "336.157px 119.765px"
    },
    id: "eldtg0anzpacq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.17 146.91a.71.71 0 0 1-.61-.34l-1.94-3.2a.71.71 0 1 1 1.21-.74l1.94 3.2a.72.72 0 0 1-.24 1 .68.68 0 0 1-.36.08Zm-3.88-6.4a.71.71 0 0 1-.61-.34l-1.94-3.2a.72.72 0 0 1 .24-1 .71.71 0 0 1 1 .24l1.94 3.2a.72.72 0 0 1-.6 1.08Zm-3.88-6.4a.73.73 0 0 1-.61-.35l-1.94-3.2a.71.71 0 0 1 1.21-.73L345 133a.7.7 0 0 1-.23 1 .75.75 0 0 1-.36.11Zm-3.88-6.41a.72.72 0 0 1-.61-.34l-1.94-3.2a.71.71 0 0 1 1.22-.73l1.94 3.2a.7.7 0 0 1-.61 1.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "345.38px 134.998px"
    },
    id: "elpyf1xhtqpmo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.08 151.73a.7.7 0 0 1-.6-.35l-1-1.61a.71.71 0 0 1 1.21-.74l1 1.62a.7.7 0 0 1-.24 1 .7.7 0 0 1-.37.08Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "354.6px 150.225px"
    },
    id: "elix2asw4ltp",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stairs--inject-9",
    className: "animable",
    style: {
      transformOrigin: "137.205px 309.98px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "137.205px 309.98px"
    },
    id: "el4pgeq0wa9fk",
    className: "animable",
    d: "m149.62 258.49-44.86 26.53v24.79l-23.42 13.12v13.33l43.46 25.21 68.27-38.31V283.7l-43.45-25.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "103.07px 342.2px"
    },
    id: "elo9cp7or63am",
    className: "animable",
    d: "m81.34 322.93 43.46 25.21v13.33l-43.46-25.21v-13.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "158.935px 322.585px"
    },
    id: "elwoz7p9fmrud",
    className: "animable",
    d: "M148.21 310.24v24.79l-23.41 13.11v13.33l68.27-38.31V283.7l-44.86 26.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f",
      transformOrigin: "114.775px 328.975px"
    },
    id: "elquwxynhb9mm",
    className: "animable",
    d: "m124.8 348.14 23.41-13.11-43.45-25.22-23.42 13.12 43.46 25.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "126.485px 310.025px"
    },
    id: "el4rtcn29mws",
    className: "animable",
    d: "M148.21 335.03v-24.79l-43.45-25.22v24.79l43.45 25.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f",
      transformOrigin: "148.915px 284.365px"
    },
    id: "elxf7n24jfriq",
    className: "animable",
    d: "m148.21 310.24-43.45-25.22 44.86-26.53 43.45 25.21-44.86 26.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-9",
    className: "animable",
    style: {
      transformOrigin: "127.244px 271.554px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.52 193.37s-10.7 15-4.34 20.19 20.31 1 20.87-1.47-16.53-18.72-16.53-18.72Z",
    style: {
      fill: "#263238",
      transformOrigin: "165.612px 204.704px"
    },
    id: "eloibadnpukf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.72 324.65 97 345.57l4.37 3.45s6.3-1.32 8.53-9.64a100 100 0 0 0 2.82-14.73Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "104.86px 336.835px"
    },
    id: "elfijjh1rvavw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.14 323.23s4.37 4 2.44 7.51-5.28 6.4-5.38 11.07-2.44 13-7.62 14.32-10.25-.48-10.15-2.32 3.57-8.24 3.57-8.24 4.76 2.95 8.27.1 4.32-14.82 4.32-14.82Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "105.25px 339.907px"
    },
    id: "el25he0rdy1vn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.14 323.23s4.37 4 2.44 7.51-5.28 6.4-5.38 11.07-2.44 13-7.62 14.32-10.25-.48-10.15-2.32 3.57-8.24 3.57-8.24 4.76 2.95 8.27.1 4.32-14.82 4.32-14.82Z",
    style: {
      opacity: 0.2,
      transformOrigin: "105.25px 339.907px"
    },
    className: "animable",
    id: "eli1xo06bn0ai"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 258.47s-35.06 14.83-37.9 16.29-7.82 4-7.32 15.43 3.37 39.74 3.37 39.74l19.22-37L168 269.34Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "131.873px 294.2px"
    },
    id: "elh9qfzywx3zn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 258.47s-35.06 14.83-37.9 16.29-7.82 4-7.32 15.43 3.37 39.74 3.37 39.74l19.22-37L168 269.34Z",
    style: {
      opacity: 0.5,
      transformOrigin: "131.873px 294.2px"
    },
    className: "animable",
    id: "elwfc7r6l64cr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.72 315.28c.74 8.08 1.41 14.65 1.41 14.65l19.22-37 35.39-16.85-8-6.29c-11.31 5.68-27.74 13.92-32.65 16.44-6.24 3.2-8.17 12.25-13.55 24.82-.61 1.38-1.21 2.78-1.82 4.23Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "125.73px 299.86px"
    },
    id: "elbu1pbldyqfo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.72 315.28c.74 8.08 1.41 14.65 1.41 14.65l19.22-37 35.39-16.85-8-6.29c-11.31 5.68-27.74 13.92-32.65 16.44-6.24 3.2-8.17 12.25-13.55 24.82-.61 1.38-1.21 2.78-1.82 4.23Z",
    style: {
      opacity: 0.7,
      transformOrigin: "125.73px 299.86px"
    },
    className: "animable",
    id: "el6sencx2lqj"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "145.7px 268.98px"
    },
    id: "elfp5ei6nuxu4",
    className: "animable",
    d: "m143.89 266.03 3.62 5.47-2.83.43-.79-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      transformOrigin: "145.7px 268.98px"
    },
    className: "animable",
    d: "m143.89 266.03 3.62 5.47-2.83.43-.79-5.9z",
    id: "elo5vninbxn2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.19 353.81s.5.84.5 5.07-1.69 5.12-3.78 5.83-8.3 5.26-10 7.24-8.56 4-15.34 2.82-8.21-5.66-4.95-8.53 12.55-8.1 12.55-8.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "79.8186px 364.465px"
    },
    id: "el5j5rw92ug87",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.37 267.23-15.08-3.49s-41.89 21-48.13 24.2-8.16 12.26-13.56 24.83c-4 9.46-9.33 22.44-12.82 30.24 0 0 2.48 6.58 10.34 4.93 2.66-5.81 7.36-11 14.2-20.24a50.45 50.45 0 0 0 9.14-19.3 6.77 6.77 0 0 1 5-5.19c6.91-1.68 21-5.33 35.88-10.45 20.97-7.22 15.03-25.53 15.03-25.53Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "133.963px 305.973px"
    },
    id: "elews47hrmyj8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.37 267.23-15.08-3.49s-41.89 21-48.13 24.2-8.16 12.26-13.56 24.83c-4 9.46-9.33 22.44-12.82 30.24 0 0 2.48 6.58 10.34 4.93 2.66-5.81 7.36-11 14.2-20.24a50.45 50.45 0 0 0 9.14-19.3 6.77 6.77 0 0 1 5-5.19c6.91-1.68 21-5.33 35.88-10.45 20.97-7.22 15.03-25.53 15.03-25.53Z",
    style: {
      opacity: 0.5,
      transformOrigin: "133.963px 305.973px"
    },
    className: "animable",
    id: "elue97tl5zcb9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.78 343c-1.15 2.57-2.1 4.58-2.75 5.71-2.63 4.57-10.3 9.52-13 11.86s-3.27 3.22-.69 5.2c6.53 5 12.19-.46 15.85-4a45.34 45.34 0 0 1 8-5.87 1.63 1.63 0 0 0 .81-1.1 27.35 27.35 0 0 1 2.13-6.86c-7.87 1.65-10.35-4.94-10.35-4.94Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "84.9035px 355.391px"
    },
    id: "elum1fytnusqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f",
      transformOrigin: "127.27px 276.325px"
    },
    id: "elinvwti648q7",
    className: "animable",
    d: "m162.38 281.55-26.37 15.22-43.85-25.35 26.37-15.54 43.85 25.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "137px 272.565px"
    },
    id: "elbxhu0h6g4tg",
    className: "animable",
    d: "m138.84 277.21-9.89-5.71 6.2-3.58 9.9 5.71-6.21 3.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "135.19px 281.165px"
    },
    id: "elkxgttgpe9d",
    className: "animable",
    d: "m134.88 292.97 13.33-7.85-26.04-15.76 12.71 23.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.66 245.92-10.55 5a93.49 93.49 0 0 0-9.31 2.88s-7.34 3-7.68 5 5.51 6.71 10.64 4.4a16.71 16.71 0 0 1 4.29-1.55 15 15 0 0 0 8.43-3.62l8.53-2.34s4.4-8.54-4.35-9.77Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "124.611px 254.872px"
    },
    id: "elhhjhkd012tl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.83 260.64c-1.22 1.31-4.7 4.61-5.46 5.56s-2.56-1.5.59-5.15a29.63 29.63 0 0 0 7.6-4.14 29.87 29.87 0 0 1-2.73 3.73Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "126.863px 261.658px"
    },
    id: "elfz1o2x8gds7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.25 209.24a10.36 10.36 0 0 0-11.46 6.95 45.43 45.43 0 0 0-2.15 10.37c-.91 10.86-1.16 16.29-1.16 16.29l-10.92 5s5.9.28 5.5 8.6l13.59-3.45Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "144.405px 232.78px"
    },
    id: "eltsqqmr8y0u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.25 209.24a10.36 10.36 0 0 0-11.46 6.95 45.43 45.43 0 0 0-2.15 10.37c-.91 10.86-1.16 16.29-1.16 16.29l-10.92 5s5.85.28 5.5 8.6l13.59-3.45Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "144.405px 232.78px"
    },
    className: "animable",
    id: "elfi7ib49scjp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.48 242.85a7.55 7.55 0 0 1 3.22 2s-1.32-2.5-3.16-3.27Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "144.09px 243.215px"
    },
    id: "el3ucs61o3vpu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.48 242.85a7.55 7.55 0 0 1 3.22 2s-1.32-2.5-3.16-3.27Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "144.09px 243.215px"
    },
    className: "animable",
    id: "elo1ghn0tr9s"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.47 184.58s-6.74-2-4.31-9.61 19.62-10.87 32.56 0c0 0 9.08-1.4 9.08 11.28s-5.08 18.47 2.74 21.77c0 0-4.77 4.52-8.63 0 0 0-.81 9.9-15.44 6.45Z",
    style: {
      fill: "#263238",
      transformOrigin: "170.086px 191.593px"
    },
    id: "elueffu8yp91",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.47 213.56 7.66 3.26v22.46a49.82 49.82 0 0 0-3.83 18.12v11.12s-15.66 5.58-27.8-.46c-5.88-2.92-9.52-9.59-9.52-9.59s6.47-3.81 6.47-8.46a64.74 64.74 0 0 0-1.29-10.81 13 13 0 0 1-3.73-10.89c.86-7.42 14.82-19.07 14.82-19.07l5.2.71Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "161.555px 240.055px"
    },
    id: "eljfl1eac1n9h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa8a7",
      transformOrigin: "168.46px 204.48px"
    },
    id: "el1dnxgulhnvu",
    className: "animable",
    d: "m174.47 213.56-12.02-3.61V195.4h12.02v18.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.45 210a19.32 19.32 0 0 0 11-10.5v-4h-11Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "167.95px 202.75px"
    },
    id: "el2hobsnhmg99",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.65 175.69s-11 .64-9.64 19.45c.63 8.69 2.66 13.19 9.36 12.86 7.58-.37 18.35-5.58 17.65-20.46s-17.37-11.85-17.37-11.85Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "163.473px 191.727px"
    },
    id: "elctivh4ks0j5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.47 195.4s-3 .8-3-3.52c0 0-13.4-.91-16.36-14.21 0 0 1.32-4 9.69-4s15.39 7.39 13.21 17.56Z",
    style: {
      fill: "#263238",
      transformOrigin: "166.761px 184.564px"
    },
    id: "el7ht434non29",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f28f8f",
      transformOrigin: "156.175px 194.595px"
    },
    id: "el91ez3t5i5wd",
    className: "animable",
    d: "M158.07 191.36v6.47l-3.79-1.16 3.79-5.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.76 192.05a1.32 1.32 0 1 1-1.31-1.32 1.31 1.31 0 0 1 1.31 1.32Z",
    style: {
      fill: "#263238",
      transformOrigin: "162.44px 192.05px"
    },
    id: "elz6bmby2890b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.1 191.13a1.32 1.32 0 1 1-1.31-1.31 1.32 1.32 0 0 1 1.31 1.31Z",
    style: {
      fill: "#263238",
      transformOrigin: "153.78px 191.14px"
    },
    id: "elt3si2t455p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.18 188.39 2.58-1.53s-1-1-2-.41a1.8 1.8 0 0 0-.58 1.94Z",
    style: {
      fill: "#263238",
      transformOrigin: "153.428px 187.327px"
    },
    id: "el1t2trr2d1n6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.4 200a6.69 6.69 0 0 0 4.24-1.14s.29 2.24-1.58 2.66a2.41 2.41 0 0 1-2.66-1.52Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "160.528px 200.207px"
    },
    id: "elzhyh2pzw4r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.41 195.89a7.27 7.27 0 0 1 .59-3.19 3.37 3.37 0 0 1 2.93-2.29c3.37-.09 3.83 3.16 3.78 4.32-.12 3-2.58 6.32-7.16 6.45Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "177.058px 195.794px"
    },
    id: "eluay03fzmnt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.45 210-3.55 4.61a4.49 4.49 0 0 0 1.47 6.71 7.66 7.66 0 0 0 9.53-2l4.57-5.71Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "166.22px 216.096px"
    },
    id: "eloco6rebjino",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.38 265.4-10 5.47a31.13 31.13 0 0 0-4.62 0c-1.78.22-6.5 1.08-7.72 1.13s-.05 2.33 3.15 2.13c0 0-7.21 3.3-7.47 5.28s5.78 6.48 10.82 4a16.35 16.35 0 0 1 4.21-1.72 15.11 15.11 0 0 0 8.28-4l8.43-2.7s3.7-8.73-5.08-9.59Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "151.973px 274.769px"
    },
    id: "el2u6ugkwz5zn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.13 216.82S176 221 177.05 234a152.64 152.64 0 0 1 0 23.63l-14.68 7.77a11.21 11.21 0 0 1 5 9.59s21.08-4.34 22.34-9.25 1.72-28.4 1.72-32.48-1.64-13.18-9.3-16.44Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "176.9px 245.905px"
    },
    id: "elafik3arqv54",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.13 216.82S176 221 177.05 234a152.64 152.64 0 0 1 0 23.63l-14.68 7.77a11.21 11.21 0 0 1 5 9.59s21.08-4.34 22.34-9.25 1.72-28.4 1.72-32.48-1.64-13.18-9.3-16.44Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "176.9px 245.905px"
    },
    className: "animable",
    id: "el1tje9j1sen5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.06 257.63a12 12 0 0 1 4.72.86 10.08 10.08 0 0 0-4.63-2Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "179.42px 257.49px"
    },
    id: "el5595o275pg5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.06 257.63a12 12 0 0 1 4.72.86 10.08 10.08 0 0 0-4.63-2Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "179.42px 257.49px"
    },
    className: "animable",
    id: "elodeltzhxi9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.05 242.36 4.58 30a.09.09 0 0 0 0 .05l45.55 26.42a.07.07 0 0 0 .1-.07l-4.45-29.11a4.28 4.28 0 0 0-2-3L88.07 241a1.33 1.33 0 0 0-2.02 1.36Z",
    style: {
      fill: "#455a64",
      transformOrigin: "111.155px 269.815px"
    },
    id: "el08aofmfph0eq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.21 298.84 24.32-14.09a3.71 3.71 0 0 0 1.85-3.2L136 296.77Z",
    style: {
      fill: "#263238",
      transformOrigin: "149.19px 290.195px"
    },
    id: "el2gcudwlntpe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.4 271.28c0 2.15-1.5 3-3.36 1.94a7.43 7.43 0 0 1-3.36-5.82c0-2.14 1.51-3 3.36-1.94a7.42 7.42 0 0 1 3.36 5.82Z",
    style: {
      fill: "#37474f",
      transformOrigin: "109.04px 269.341px"
    },
    id: "eltuekhsuekhm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.25 240.81s9.19 2.5 14.07-4.4c0 0-3.16 8.91-14.07 4.4Z",
    style: {
      opacity: 0.2,
      transformOrigin: "164.285px 239.247px"
    },
    className: "animable",
    id: "el134ky1p4yhwh"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDownloads);
export default __webpack_public_path__ + "static/media/noDownloads.f32d647ec67967601123029557e5f6a0.svg";
export { ForwardRef as ReactComponent };